<template>
  <div class="contact">
    <!-- <div class="contact__btn contact__btn-customer" @click="handleCustomerServiceClick">
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线客服</div>
    </div>

    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:0571-85785223" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>电话咨询</div>
      </a>
      <div class="phone-number">0571-85785223</div>
    </div>
    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:400-0878-198" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>申请试用</div>
      </a>
      <div class="phone-number">400-0878-198</div>
    </div> -->
    <!--右边侧边栏-->
    <div class="ask_o">
      <div class="pc ask">
        <div class="item customer_service" @click="handleCustomerServiceClick()">
          <!-- <img
            class="ask_o_icon"
            src="/images/customer_service_210118.png"
            alt="在线客服"
          /> -->
          <img class="ask_o_icon" :src="require('@/assets/images/icon-headphone-white.svg')" />
          <p class="ask_o_discription">在线客服</p>
        </div>
        <div class="item ask_o_phone_call">
          <div class="ask_o_phone_call_right">
            <a href="tel:0571-85785223" class="ask_o_phone_number_box">
              <p class="ask_o_discription">销售热线</p>
              <p class="ask_o_phone_number" style="font-weight:600;">0571-85785223</p>
            </a>
            <a href="tel:4000878198" class="ask_o_phone_number_box second">
              <p class="ask_o_discription">售后服务</p>
              <p class="ask_o_phone_number" style="font-weight:600;">400-0878-198</p>
            </a>
          </div>
          <div class="ask_o_phone_call_left">
            <div class="ask_o_icon"></div>
            <p class="ask_o_discription">电话咨询</p>
          </div>
        </div>
        <!--申请试用-->
        <div class="item ask_o_apply_use">
          <a href="javascript:;" @click="showDialog">
            <div class="ask_o_icon"></div>
            <p class="ask_o_discription">申请试用</p>
          </a>
        </div>
        <div class="item ask_o_to_top" v-show="true" @click="handleBackToTopClick">
          <a href="javascript:;">
            <div class="arrow-top"></div>
            <p class="ask_o_discription">返回顶部</p>
          </a>
        </div>
      </div>
      <div class="m">
        <a href="javascript:;" @click="handleCustomerServiceClick" class="md__sign_officewebsite_onlineservice">
          <img src="@/assets/images/erji.png" alt="" />在线客服
        </a>
        <a href="javascript:;" class="md__sign_officewebsite_phonecallconsult"> <img src="@/assets/images/phone.png" alt="" />电话咨询 </a>
      </div>
      <div class="md__sign_officewebsite_phonecallconsult_dialog">
        <div class="md__sign_officewebsite_phonecallconsult_mask"></div>
        <div class="md__sign_officewebsite_phonecallconsult_content">
          <a href="tel:0571-85785223" class="mb_mask_o_phone_number_box first">
            <p class="mb_mask_o_discription">销售热线：</p>
            <p class="mb_mask_o_phone_number">0571-85785223</p>
          </a>
          <a href="tel:4000878198" class="mb_mask_o_phone_number_box second">
            <p class="mb_mask_o_discription">售后服务：</p>
            <p class="mb_mask_o_phone_number">400-0878-198</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qiyuMixin from '../mixins/qiyu.js'

export default {
  mixins: [qiyuMixin],
  components: {
    // BackToTop: () => import('./BackToTop.vue'),
  },
  mounted() {
    this.addQiyuScript()
  },
  data() {
    return {
      timerss: '',
    }
  },
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
  },
  methods: {
    showDialog() {
      this.$emit('showDialog')
    },
    handleBackToTopClick() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },

    // mdMaskClick() {
    //   $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'none')
    //   document.documentElement.style.overflow = 'auto'
    // },

    // mbCallClick() {
    //   $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'block')
    //   document.documentElement.style.overflow = 'hidden'
    // },
  },
}
</script>

<style lang="less" scoped>
.contact /deep/ .back-to-top {
  // position: relative;
  // bottom: 0;
  // right: 0;
  // overflow: hidden;
  display: inline-block;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}
.contact {
  display: block;
  position: fixed;
  bottom: 50%;
  right: 0;
  transform: translateY(50%);
  z-index: 9990;
  width: 80px;
  text-align: right;

  &__btn {
    flex-shrink: 0;
    display: inline-block;
    width: 60px;
    height: 40px;
    background-color: #e61717;
    color: #fff;
    font-size: 12px;
    padding: 10px 0;
    text-align: center;
    margin-bottom: 1px;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    box-sizing: content-box;

    &-customer {
      padding-right: 0;
      transition: padding 200ms;

      &:hover {
        padding-right: 20px;
      }
    }
    img {
      height: 26px;
      width: 26px;
      margin: 0 auto;
    }
  }

  &__btn-phone {
    display: flex;
    width: 400px;
    margin-left: 20px;
    transition: margin 200ms;

    .phone-number {
      font-size: 20px;
      line-height: 60px;
      height: 60px;
      color: #fff;
      background-color: #e61717;
      padding-right: 10px;
    }

    &:hover {
      margin-left: -140px;
    }
  }
}
.ask_o .ask {
  width: 84px;
  height: 280px;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10000;
}
.ask_o .ask .item {
  cursor: pointer;
}
.ask_o .ask .customer_service {
  position: absolute;
  top: 0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .customer_service:hover {
  width: 68px;
}
.ask_o .ask .ask_o_phone_call {
  position: absolute;
  top: 65px;
  right: 0;
}
.ask_o .ask .ask_o_to_top {
  position: absolute;
  top: 100px;
  right: 0;
  .arrow {
    background-color: red;
    width: 15px;
    height: 15px;
    transform: rotateZ(45deg);
    border: 0;
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    margin: 15px auto 5px;
  }
  .arrow-top {
    width: 16px;
    height: 16px;
    background: url('../../../../assets/images/to-top.png') no-repeat;
    background-size: contain;
  }
  &:hover {
    .arrow-top {
      width: 16px;
      height: 16px;
      background: url('../../../../assets/images/to-top-active.png') no-repeat;
      background-size: contain;
    }
  }
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left {
  position: absolute;
  top: 0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover {
  width: 68px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_icon {
  background: url('../../../../assets/images/grayPhone.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover .ask_o_icon {
  background: url('../../../../assets/images/redPhone.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover .ask_o_discription {
  color: #e61717;
}
.ask_o .ask .ask_o_phone_call:hover .ask_o_phone_call_right {
  opacity: 1;
  visibility: visible;
}
.ask_o .ask .ask_o_weixin_call {
  position: absolute;
  top: 130px;
  right: 0;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left {
  position: absolute;
  top: 0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover {
  width: 68px;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_icon {
  // background: url('../images/floatrightImage/grayWeixin.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover .ask_o_icon {
  // background: url('../images/floatrightImage/redWeixin.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover .ask_o_discription {
  color: #e61717;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_right {
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  width: 145px;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  border: 1px solid #dcdee2;
  position: absolute;
  top: 0px;
  right: 80px;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_right .text {
  margin-top: 10px;
  text-align: center;
  color: #666666;
}
.ask_o .ask .ask_o_weixin_call:hover .ask_o_weixin_call_right {
  opacity: 1;
  visibility: visible;
}

.ask_o .ask .ask_o_apply_use {
  position: absolute;
  top: 130px;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_to_top {
  position: absolute;
  top: 195px;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_apply_use a,
.ask_o .ask .ask_o_to_top a {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}
.ask_o .ask .ask_o_apply_use:hover {
  width: 68px;
}
.ask_o .ask .ask_o_to_top:hover {
  width: 68px;
}
.ask_o .ask .ask_o_apply_use .ask_o_icon {
  background: url('../../../../assets/images/grayNotebook.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_apply_use:hover .ask_o_icon {
  background: url('../../../../assets/images/redNotebook.png') no-repeat top left;
  background-size: 20px;
}
.ask_o .ask .ask_o_apply_use:hover .ask_o_discription {
  color: #e61717;
}
.ask_o .ask .customer_service {
  background: #e61717;
}
.ask_o .ask .customer_service:hover {
  background: #e63717;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left,
.ask_o .ask .ask_o_apply_use,
.ask_o .ask .ask_o_to_top {
  width: 100%;
  height: 100%;
  background: #ffffff;
}
.ask_o .ask .customer_service,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left,
.ask_o .ask .ask_o_apply_use,
.ask_o .ask .ask_o_to_top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ask_o .ask .customer_service,
.ask_o .ask .ask_o_phone_call,
.ask_o .ask .ask_o_weixin_call,
.ask_o .ask .ask_o_apply_use,
.ask_o .ask .ask_o_to_top {
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
  width: 60px;
  height: 56px;
  border-radius: 2px;
}
.ask_o .ask .customer_service .ask_o_icon,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_icon,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_icon,
.ask_o .ask .ask_o_apply_use .ask_o_icon,
.ask_o .ask .ask_o_to_top .ask_o_icon {
  width: 20px;
  height: 20px;
}
.ask_o .ask .customer_service .ask_o_discription {
  color: #ffffff;
}

.ask_o .ask .customer_service .ask_o_discription,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_discription,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_discription,
.ask_o .ask .ask_o_apply_use .ask_o_discription,
.ask_o .ask .ask_o_to_top .ask_o_discription {
  margin-top: 2px;
  word-break: break-all;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right {
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  width: 145px;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  border: 1px solid #dcdee2;
  position: absolute;
  top: 1px;
  right: 80px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_phone_number_box {
  display: inline-block;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_phone_number_box.second {
  margin-top: 6px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_discription {
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_phone_number {
  height: 22px;
  color: #e61717;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
.ask_o .ask .ask_o_back_top {
  width: 44px;
  height: 44px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease-in-out;
  border-radius: 22px;
  background: #ffffff;
  position: fixed;
  right: 20px;
  bottom: 20px;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
}
.ask_o .ask .ask_o_back_top .ask_o_icon {
  width: 14px;
  height: 14px;
  margin-left: 15px;
  margin-top: 15px;
}
.ask_o .m {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
}
.ask_o .m a {
  width: 50%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  background: #000;
}
.ask_o .m a:nth-child(2) {
  background: #e61717;
}
.ask_o .m a:nth-child(2) img {
  width: 28px;
}
.ask_o .m a img {
  width: 24px;
  margin-right: 10px;
}
.md__sign_officewebsite_phonecallconsult_dialog {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999999999999999;
  display: none;
}
.md__sign_officewebsite_phonecallconsult_dialog .md__sign_officewebsite_phonecallconsult_mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.49);
}
.md__sign_officewebsite_phonecallconsult_dialog .md__sign_officewebsite_phonecallconsult_content {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 260px;
  height: 120px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0 14px;
}
.md__sign_officewebsite_phonecallconsult_dialog .md__sign_officewebsite_phonecallconsult_content .mb_mask_o_phone_number_box {
  height: 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.md__sign_officewebsite_phonecallconsult_dialog .md__sign_officewebsite_phonecallconsult_content .mb_mask_o_phone_number_box.first {
  border: 0px solid #f2f2f2;
  border-bottom-width: 1px;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box
  .mb_mask_o_phone_number {
  font-size: 16px;
  font-weight: 400;
  color: #e61717;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box
  .mb_mask_o_discription {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

@media only screen and (max-width: 768px) {
  .ask_o .pc {
    display: none;
  }
  .ask_o .m {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
